import { render, staticRenderFns } from "./largerScreenPage.vue?vue&type=template&id=54af05b2"
import script from "./largerScreenPage.vue?vue&type=script&lang=js"
export * from "./largerScreenPage.vue?vue&type=script&lang=js"
import style0 from "./largerScreenPage.vue?vue&type=style&index=0&id=54af05b2&prod&lang=css"
import style1 from "./largerScreenPage.vue?vue&type=style&index=1&id=54af05b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports